const HOURS_IN_DAY = 24

const pluralize = (count: number, forms: readonly [string, string, string]) => {
  const lastTwoDigits = count % 100
  const lastDigit = count % 10
  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) return forms[2]
  if (lastDigit === 1) return forms[0]
  if (lastDigit >= 2 && lastDigit <= 4) return forms[1]
  return forms[2]
}

export const formatExpirationDays = (hoursValue: string) => {
  const hours = Number(hoursValue)
  if (!Number.isInteger(hours) || hours < HOURS_IN_DAY) return undefined

  const days = Math.floor(hours / HOURS_IN_DAY)
  const restHours = hours % HOURS_IN_DAY
  const daysText = `${days} ${pluralize(days, ['день', 'дня', 'дней'])}`
  if (restHours === 0) return ` (${daysText})`
  return ` (${daysText} ${restHours} ${pluralize(restHours, ['час', 'часа', 'часов'])})`
}
